<ng-container #blockHost></ng-container>

<ng-container *ngIf="!blockComponent">
  <div
    class="chat-message"
    [class.chat-message--outgoing]="message.direction === 'outgoing'"
    [class.chat-message--incoming]="message.direction === 'incoming'"
  >
    <!-- Аватар (только входящие) -->
    <div
      class="chat-message__avatar"
      *ngIf="message.direction === 'incoming' && viewConfig.showAvatar"
    ></div>

    <!-- Контент: заголовок + пузырёк -->
    <div class="chat-message__content">

      <!-- Строка над пузырьком: имя / метка + дата -->
      <div class="chat-message__header" *ngIf="viewConfig.showDateTime || (message.direction === 'incoming' && viewConfig.showSenderName) || message.direction === 'outgoing'">

        <!-- Имя отправителя (входящие) или метка «Ваше сообщение» (исходящие) -->
        <span
          class="chat-message__sender"
          *ngIf="message.direction === 'incoming' && viewConfig.showSenderName && message.senderName"
        >{{ message.senderName }}</span>

        <!-- Дата + статус -->
        <div class="chat-message__meta" *ngIf="viewConfig.showDateTime">
          <span class="chat-message__time">{{ message.createdAt | date:'EE HH:mm' }}</span>
          <span
            class="chat-message__status"
            *ngIf="message.direction === 'outgoing' && viewConfig.showDeliveryStatus && message.deliveryStatus"
          >
            <span class="chat-message__status-icon chat-message__status-icon--{{ message.deliveryStatus }}"></span>
          </span>
        </div>
      </div>

      <!-- Пузырёк -->
      <div class="chat-message__bubble" [class.chat-message__bubble--transcribing]="isTranscribing">
        <ng-container *ngIf="viewConfig.showLoadingSpinner; else plainText">
          <div class="chat-message__activity-row">
            <div class="chat-message__spinner">
              <span class="chat-message__dot"></span>
              <span class="chat-message__dot"></span>
              <span class="chat-message__dot"></span>
            </div>
            <div
              class="chat-message__text"
              [class.chat-message__text--shimmer]="isTranscribing"
              *ngIf="message.text"
            >
              <ng-container *ngIf="isTranscribing; else spinnerMarkdown">{{ message.text }}</ng-container>
              <ng-template #spinnerMarkdown>
                <span [innerHTML]="message.text | markdown"></span>
              </ng-template>
            </div>
          </div>
        </ng-container>
        <ng-template #plainText>
          <div class="chat-message__text" [innerHTML]="message.text | markdown"></div>
        </ng-template>
      </div>

    </div>
  </div>
</ng-container>
